import { Component, OnInit } from "@angular/core";
import { UsersService } from "./users.service";
import { AccountsService } from "../accounts/accounts.service";
import { Router } from "@angular/router";

@Component({
  selector: "edit-user",
  template: require('./createuser.component.html'),
  styles: [require('./createuser.component.scss')]
})
export class EditUserComponent implements OnInit {
  clicked: boolean = false;
  activePanels: string[] = ["details"];
  editMode: boolean = true;
  users: any[] = [];
  sent: boolean = false;
  projects: any[] = [];
  accountProjects: any[] = [];
  account: any;

  constructor(private service: UsersService, private router: Router) {}

  ngOnInit() {
    this.account = AccountsService.currentAccount;
    this.users.push(UsersService.currentUser);
    if (!this.users || typeof this.users[0] === "undefined") {
      this.router.navigate(["/accounts"]);
    } else {
      this.getProjects();
    }
  }

  getProjects() {
    this.service.getProjects().subscribe((projects) => {
      this.projects = projects;
      this.accountProjects = this.projects.filter((it) => {
        return AccountsService.currentAccount.project_ids.indexOf(it.id) > -1;
      });
      this.getProjectMembers();
    });
  }

  getProjectMembers() {
    this.service
      .getProjectMemberList(AccountsService.currentAccount.project_ids)
      .subscribe((members) => {
        this.users.map((user) => {
          members.map((member) => {
            if (member.user_id === user.id) {
              if (!user.projects) {
                user.projects = [];
              }
              let project = this.projects.filter((it) => {
                return it.id === member.project_id;
              })[0];
              user.projects.push({
                name: project.name,
                id: project.id,
                role: member.role
              });
            }
          });
        });
      });
  }

  resendActivationLink() {
    const user = this.users[0];
    this.service.resendActivationLink(user).subscribe((resp) => {
      this.back();
    });
  }

  isValid() {
    return this.users[0].name && this.users[0].email;
  }

  back() {
    window.history.back();
  }

  onSubmit() {
    this.activePanels = [];
    if (!this.sent) {
      this.sent = true;
      this.service.editUser(this.users[0]).subscribe(
        (res) => {
          this.back();
        },
        (error) => {
          this.sent = false;
          setTimeout(() => {
            this.activePanels = ["details"];
          }, 1);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/users/edituser.component.ts